import React, { useEffect, useState } from 'react';
import 'react-phone-input-2/lib/bootstrap.css';
import PhoneInput from 'react-phone-input-2';
import Typography from '@mui/material/Typography';
import { equals, not, pathOr, replace } from 'ramda';
import { isValidMobile } from 'src/utilities/mobileValidator';
import { isNotEmpty } from 'src/utilities/hasValue';
import { getTheme } from 'src/utilities/siteSettings';
import SiteSettings from 'src/siteSetting';

const theme = getTheme();

interface Props {
  value?: any;
  onChange?: any;
  onBlur?: () => void;
  onKeyPress?: any;
  name?: any;
  style?: (e: any) => void
  onFocusStyle?: (e: any) => void
  disableHint?: any
  displayErrorUnder?: boolean
}
type CombinedProps = Props;
const USPhoneNumber: React.FC<CombinedProps> = (props: CombinedProps) => {
  const { value, onChange, onBlur, onKeyPress = () => { }, name, style = () => { }, onFocusStyle, disableHint, displayErrorUnder = false } = props;
  const [phoneValue, setValue]: any = useState(value || '');
  const updValue = replace(/\D/g, '', value);
  const [focus, setFocus] = useState(false)

  useEffect(() => {
    if (not(equals(value, phoneValue))) {
      setValue(value)
    }

  }, [value])

  const handleChange = (value: string) => {
    onChange(value);
    setValue(value);
  };
  const handleError = () => {
    if (displayErrorUnder) {
      return isValidMobile(updValue)
    }
    return isNotEmpty(phoneValue) && isValidMobile(updValue)
  };

  const handlePhoneInputValidity = () => {
    return displayErrorUnder || isNotEmpty(phoneValue) && isValidMobile(updValue)
  }

  const handleOnBlur = () => {
    if (onBlur) {
      onBlur()
      return
    }
    if (onFocusStyle) {
      setFocus(false)
    }
  };

  const generateStyleOverride = () => {
    if (focus) {
      return onFocusStyle ? onFocusStyle({ error: !!handleError() }) : style;
    }

    return style(!!handleError());
  };

  const borderColor = handleError() ? pathOr('', ['palette', 'basic', 'red'], theme) : SiteSettings.buttonBorderColor()

  const styleOverride = generateStyleOverride()
  return (
    <>
      <PhoneInput
        isValid={handlePhoneInputValidity}
        disableCountryCode={true}
        disableDropdown={true}
        enableAreaCodes={true}
        onlyCountries={['us']}
        preferredCountries={['us']}
        enableTerritories
        country={'us'}
        value={phoneValue}
        onChange={handleChange}
        placeholder="(123)-456-7890"
        buttonStyle={{ display: 'none' }}
        specialLabel=""
        inputStyle={{
          padding: '10px',
          fontFamily: 'Open Sans, sans-serif',
          border: `1px solid ${borderColor}`,
          borderRadius: 4,
          minWidth: 315,
          minHeight: 56,
          boxShadow: '0px 0px 0px',
          fontSize: 14,
          width: "100%",
          ...styleOverride
        }}
        inputProps={{
          "id": 'us-phone-number-input',
          "test-data-id": 'us-phone-number-input',
          "data-test-id": name
        }}
        onBlur={handleOnBlur}
        onFocus={() => setFocus(true)}
        onKeyDown={onKeyPress}
      />
      {!disableHint &&
        <Typography fontSize={11} color="basic.softGrey" mt={1}>
          i.e.: (123)-456-7890
        </Typography>
      }
      {displayErrorUnder && (
        <Typography fontSize={12} color="error.main" mt={1}>
          {handleError() || ''}
        </Typography>
      )}
    </>
  );
};

export default USPhoneNumber;
